module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[13]500.793b009.woff2";